import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error, className, disabled, ...rest }, ref) => {
    const classes = [
      styles.input,
      error ? styles.error : '',
      className ?? '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <input
        ref={ref}
        className={classes}
        disabled={disabled}
        aria-invalid={error || undefined}
        {...rest}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;
